import { parseDateApiFormat } from '../../utils/parseDateFormats';

export const getPerDiems = (state) => {
  return state.perDiems;
};

export const getDistrictId = (state) => {
  const { district } = getPerDiems(state);
  return (district === null) ? null : district.id;
};

export const getDepartmentId = (state) => {
  const { department } = getPerDiems(state);
  return (department === null) ? null : department.id;
};

export const getPerDiemId = (state) => {
  const { perDiemId } = getPerDiems(state);
  return perDiemId;
};

export const getPerDiemState = (state) => {
  const { perDiemState } = getPerDiems(state);
  return perDiemState;
};

export const getUser = (state) => {
  const { user } = getPerDiems(state);
  return user;
};

export const getUserId = (state) => {
  const { user } = getPerDiems(state);
  return (user) ? user.id : null;
};

export const getTicketJobNumber = (state) => {
  const { ticketJobNumber } = getPerDiems(state);
  return ticketJobNumber;
};

export const getSorted = (state) => {
  const { sorted } = getPerDiems(state);
  return sorted;
};

export const getPageSize = (state) => {
  const { pageSize } = getPerDiems(state);
  return pageSize;
};

export const getRequestedAtDate = (state) => {
  const { requestedAt } = getPerDiems(state);
  return (!requestedAt) ? requestedAt : parseDateApiFormat(requestedAt);
};

export const getRequestedForDate = (state) => {
  const { requestedForDate } = getPerDiems(state);
  return (!requestedForDate) ? requestedForDate : parseDateApiFormat(requestedForDate);
};

export const getPaymentDate = (state) => {
  const { paymentDate } = getPerDiems(state);
  return (!paymentDate) ? paymentDate : parseDateApiFormat(paymentDate);
};

export const getTableDataRequest = (state) => {
  const { tableDataRequest } = getPerDiems(state);
  return tableDataRequest;
};

/* NOTE: selectors for the cursorObjects */
export const getPrevCursorObject = (state) => {
  const { prevCursorObject } = getPerDiems(state);
  return prevCursorObject;
};

export const getNextCursorObject = (state) => {
  const { nextCursorObject } = getPerDiems(state);
  return nextCursorObject;
};

export const getFirstPageSize = (state) => {
  const { first } = getNextCursorObject(state);
  return first;
};

export const getBeforePageSize = (state) => {
  const { last } = getPrevCursorObject(state);
  return last;
};

export const getNextCursor = (state) => {
  const { cursorPosition } = getNextCursorObject(state);
  return cursorPosition;
};

export const getPrevCursor = (state) => {
  const { cursorPosition } = getPrevCursorObject(state);
  return cursorPosition;
};

export const getDateOrder = (state) => {
  const { dateOrderBy } = getPerDiems(state);
  return dateOrderBy;
};
